import Vue from 'vue'
import Router from 'vue-router'
import DealerRegister from '../views/DealerRegister.vue'
import ContactInformation from '../views/DealerRegister/ContactInformation.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/DealerRegister'
    },
    {
      path: '/DealerRegister',
      redirect: '/DealerRegister/ContactInformation',
      name: 'DealerRegister',
      component: DealerRegister,
      children: [
        {
          path: '/DealerRegister/ContactInformation',
          name: 'ContactInformation',
          component: ContactInformation
        },
        {
          path: '/DealerRegister/CompanyInformation',
          name: 'CompanyInformation',
          component: () =>
            import('../views/DealerRegister/CompanyInformation.vue')
        },
        {
          path: '/DealerRegister/CompleteRegister',
          name: 'CompleteRegister',
          component: () =>
            import('../views/DealerRegister/CompleteRegister.vue')
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js